enum CompanyAccessRequestStatus {
  Approved = 'Approved',
  Active = 'Active',
  Canceled = 'Canceled',
  Pending = 'Pending',
  Rejected = 'Rejected',
}

export default CompanyAccessRequestStatus;
